import {dashboard, trend} from '../utils/Icons'

export const menuItems = [
    {
        id: 1,
        title: 'Récapitulatif',
        icon: dashboard,
        link: '/dashboard'
    },
    {
        id: 3,
        title: "Récupérations",
        icon: trend,
        link: "/dashboard",
    }
]